import { Text, VStack } from "@meditect/medibase-components";

import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";

export const ForbiddenResourceError: ErrorMessageComponent<Record<string, unknown>> = () => {
  return (
    <VStack align="stretch" color="gray.700" textAlign="start">
      <Text>Votre rôle ne vous autorise pas à effectuer cette action.</Text>
      <Text fontWeight={600}>Rapprochez-vous du titulaire de la pharmacie pour faire modifier vos droits.</Text>
    </VStack>
  );
};
